import { FC, useState } from 'react';

const CopyToClipboard: FC<{ code: string }> = ({ code }) => {
  const [isCopied, setIsCopied] = useState(false);

  const handleCopyClick = () => {
    navigator.clipboard
      .writeText(code)
      .then(() => {
        setIsCopied(true);
        setTimeout(() => {
          setIsCopied(false);
        }, 6000);
      })
      .catch((error) => console.error('Unable to copy to clipboard', error));
  };

  return (
    <div className="relative inline-block">
      <button
        onClick={handleCopyClick}
        className="bg-gray-200 p-2 rounded-full hover:bg-gray-300 focus:outline-none"
        title="Copy to Clipboard"
      >
        {isCopied ? (
          <i className="ra-icons-generic-check-mark flex text-neutral-500 mr-2"></i>
        ) : (
          <i className="ra-icons-generic-copy flex text-neutral-500 mr-2"></i>
        )}
      </button>
    </div>
  );
};

export default CopyToClipboard;
